
import { Options, Vue } from 'vue-class-component'
import clubPointRules from '@/components/Memberportal/ClubPointRules/index.vue'

@Options({
  components: {
    clubPointRules
  }
})
export default class clubPointRulesPage extends Vue {}
